import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=4048cde7&scoped=true&"
import script from "./MenuDrawer.vue?vue&type=script&lang=js&"
export * from "./MenuDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MenuDrawer.vue?vue&type=style&index=0&id=4048cde7&prod&scoped=true&lang=css&"
import style1 from "./MenuDrawer.vue?vue&type=style&index=1&id=4048cde7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048cde7",
  null
  
)

export default component.exports